export type PaidTier = "growth" | "scale";

export interface ParsedPricingFlowState {
  checkoutStatus: "success" | "canceled" | null;
  checkoutIntentPlan: PaidTier | null;
  checkoutIntentPromo: string | null;
}

export function parsePricingFlowState(search: string): ParsedPricingFlowState {
  const params = new URLSearchParams(search);
  const checkoutStatusParam = params.get("checkout");
  const intentParam = params.get("intent");
  const planParam = params.get("plan");
  const promoParam = params.get("promo");

  const checkoutStatus =
    checkoutStatusParam === "success" || checkoutStatusParam === "canceled"
      ? checkoutStatusParam
      : null;

  const checkoutIntentPlan =
    intentParam === "checkout" && (planParam === "growth" || planParam === "scale")
      ? planParam
      : null;

  return {
    checkoutStatus,
    checkoutIntentPlan,
    checkoutIntentPromo: checkoutIntentPlan ? promoParam : null,
  };
}

export function buildPricingCheckoutIntentPath(plan: PaidTier, promoCode?: string | null): string {
  const params = new URLSearchParams({
    intent: "checkout",
    plan,
  });
  const normalizedPromo = promoCode?.trim();
  if (normalizedPromo) {
    params.set("promo", normalizedPromo);
  }
  return `/pricing?${params.toString()}`;
}

export function sanitizeNextPath(input: string | null): string | null {
  if (!input || !input.startsWith("/") || input.startsWith("//")) {
    return null;
  }
  return input;
}
